module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "auth-area"
  }, [_c('div', {
    staticClass: "auth-window auth-window-activate"
  }, [_c('div', {
    staticClass: "auth-logo auth-logo-activate"
  }, [_c('img', {
    attrs: {
      "src": _vm.logoUrl,
      "alt": "Widget Brain logo"
    }
  })]), _vm._v(" "), (_vm.correctAccess && !_vm.activationSuccess) ? _c('form', {
    staticClass: "auth-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.activateUser.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "auth-welcome-text"
  }, [_vm._v("\n          Hi" + _vm._s(this.firstname ? " " + this.firstname + ", " : ", ") + "Welcome\n          to Widget Brain. We've set up an account for you to access\n          " + _vm._s(_vm.application ? " " + _vm.application : "") + ". You just have to pick a\n          username and a strong password.\n        ")]), _vm._v(" "), _c('md-input-container', {
    class: {
      valid: _vm.isUsernameValid
    }
  }, [_c('label', [_vm._v("Username")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1), _vm._v(" "), (_vm.usernameRequirements.length > 0) ? _c('div', [_c('ul', {
    staticClass: "errors-list"
  }, _vm._l((_vm.usernameRequirements), function(requirement, index) {
    return _c('li', {
      key: index
    }, [_vm._v("\n              " + _vm._s(requirement) + "\n            ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('md-input-container', {
    class: {
      valid: _vm.isPasswordValid
    },
    attrs: {
      "md-has-password": ""
    }
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), (_vm.passwordRequirements.length > 0) ? _c('div', [_c('ul', {
    staticClass: "errors-list"
  }, _vm._l((_vm.passwordRequirements), function(requirement, index) {
    return _c('li', {
      key: index
    }, [_vm._v("\n              " + _vm._s(requirement) + "\n            ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('md-input-container', {
    class: {
      valid: _vm.isPasswordRepeatValid
    },
    attrs: {
      "md-has-password": ""
    }
  }, [_c('label', [_vm._v("Repeat password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.passwordRepeat),
      callback: function($$v) {
        _vm.passwordRepeat = $$v
      },
      expression: "passwordRepeat"
    }
  })], 1), _vm._v(" "), (
    _vm.passwordRepeatRequirements &&
    _vm.passwordRepeatRequirements.length > 0
  ) ? _c('div', [_c('ul', {
    staticClass: "errors-list"
  }, _vm._l((_vm.passwordRepeatRequirements), function(requirement, index) {
    return _c('li', {
      key: index
    }, [_vm._v("\n              " + _vm._s(requirement) + "\n            ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "auth-actions"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    attrs: {
      "disabled": !_vm.isUsernameValid || !_vm.isPasswordValid || !_vm.isPasswordRepeatValid,
      "type": "submit"
    },
    on: {
      "submit": _vm.activateUser
    }
  }, [_vm._v("\n            Activate\n          ")])], 1), _vm._v(" "), _vm._m(0)], 1) : _vm._e(), _vm._v(" "), (!_vm.correctAccess && !_vm.activationSuccess) ? _c('div', {
    staticClass: "auth-welcome-text auth-text-center"
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("\n          We will redirect you to the Login page in\n          "), _c('span', {
    staticClass: "highlighted"
  }, [_vm._v(_vm._s(_vm.countDown))]), _vm._v(" second" + _vm._s(_vm.countDown > 1 ? "s" : "") + ". "), _c('br'), _vm._v("\n          Or click the button bellow to redirect now.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "auth-actions auth-spaced"
  }, [_c('md-button', {
    staticClass: "md-raised md-secondary",
    on: {
      "click": _vm.redirectToALFA
    }
  }, [_vm._v("\n            Redirect Now\n          ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.correctAccess && _vm.activationSuccess) ? _c('div', {
    staticClass: "auth-welcome-text auth-text-center"
  }, [_c('p', [_vm._v("Your account has been activated!")]), _vm._v(" "), _c('p', [_vm._v("\n          You will be forwarded to ALFA in\n          "), _c('span', {
    staticClass: "highlighted"
  }, [_vm._v(_vm._s(_vm.countDown))]), _vm._v(" second" + _vm._s(_vm.countDown > 1 ? "s" : "") + ". "), _c('br'), _vm._v("\n          Or click the button bellow to redirect now.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "auth-actions auth-spaced"
  }, [_c('md-button', {
    staticClass: "md-raised md-secondary",
    on: {
      "click": _vm.redirectToALFA
    }
  }, [_vm._v("\n            Redirect Now\n          ")])], 1)]) : _vm._e()])]), _vm._v(" "), _c('md-dialog', {
    ref: "credentialsDialog"
  }, [_c('md-dialog-title', [_vm._v(" Credentials ")]), _vm._v(" "), _c('md-dialog-content', [_c('b', [_vm._v("Client ID:")]), _vm._v(" " + _vm._s(_vm.clientId)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Client Secret:")]), _vm._v(" " + _vm._s(_vm.clientSecret)), _c('br')]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    on: {
      "click": _vm.loginUser
    }
  }, [_vm._v("Ok")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "terms-of-use"
  }, [_c('p', [_vm._v("\n            By creating an account, you agree that your personal data will be\n            used as follows:\n          ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Full Name: application personalisation only;")]), _vm._v(" "), _c('li', [_vm._v("\n              Username and email: system monitoring and event logging within\n              Widget Brain apps.\n            ")])]), _vm._v(" "), _c('p', [_vm._v("\n            Your personal data will not be shared with third parties outside\n            of your organization and Widget Brain. If this invite expires,\n            your account details are removed after 7 days.\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          Looks like your Email or Activation key is invalid or expired.\n          "), _c('br'), _vm._v("\n          Please contact your Administrator for assistance.\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-13b5bf7a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Activate.vue
// module id = 298
// module chunks = 2